
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { NotificationModel } from 'models/generated/Communication.Api.Models.Notification';


const _communication_NotificationControllerHelper = new Map<string, Object>();
_communication_NotificationControllerHelper.set('GetActiveNotifications', NotificationModel);
_communication_NotificationControllerHelper.set('GetNotification', NotificationModel);
_communication_NotificationControllerHelper.set('UpdateNotificationStatus', NotificationModel);


export const communication_NotificationControllerHelper = _communication_NotificationControllerHelper;

